import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { motion, useAnimation } from 'framer-motion';

// Import images
import leader1 from '../../assets/img/Aboutus9/1.png';
import leader2 from '../../assets/img/Aboutus9/2.png';
import leader3 from '../../assets/img/Aboutus9/3.png';
import leader4 from '../../assets/img/Aboutus9/4.png';

const Aboutus9 = () => {
    const leaders = [
        { name: "Mayur Panchal", role: "General Manager", image: leader1 },
        { name: "Samaan Turk", role: "BIM Manager", image: leader2 },
        { name: "Sonam Vishwakarma", role: "CAD Manager", image: leader3 },
        { name: "Aakanksha Damani", role: "HR Executive", image: leader4 }
    ];

    const controls = useAnimation();
    const [currentIndex, setCurrentIndex] = useState(leaders.length);
    const [isMoving, setIsMoving] = useState(false);
    const [cardsToShow, setCardsToShow] = useState(4);

    useEffect(() => {
        const updateCards = () => {
            const width = window.innerWidth;
            if (width < 641) setCardsToShow(1);
            else if (width < 1025) setCardsToShow(2);
            else setCardsToShow(4);
        };
        updateCards();
        window.addEventListener('resize', updateCards);
        return () => window.removeEventListener('resize', updateCards);
    }, []);

    useEffect(() => {
        controls.set({ x: `-${currentIndex * (100 / cardsToShow)}%` });
    }, [cardsToShow, leaders.length]);

    const moveSlide = async (newIndex) => {
        if (isMoving) return;
        setIsMoving(true);
        setCurrentIndex(newIndex);
        
        await controls.start({
            x: `-${newIndex * (100 / cardsToShow)}%`,
            transition: { type: "spring", stiffness: 150, damping: 25, mass: 1 }
        });

        if (newIndex >= leaders.length * 2) {
            const resetIndex = newIndex - leaders.length;
            controls.set({ x: `-${resetIndex * (100 / cardsToShow)}%` });
            setCurrentIndex(resetIndex);
        } else if (newIndex < leaders.length) {
            const resetIndex = newIndex + leaders.length;
            controls.set({ x: `-${resetIndex * (100 / cardsToShow)}%` });
            setCurrentIndex(resetIndex);
        }
        setIsMoving(false);
    };

    return (
        <section className="aboutus9-section">
            <div className="aboutus9-container">
                <div className="aboutus9-header">
                    <h2 className="title">Meet Our <span className="text-secondary">Leadership</span></h2>
                    <p className="desc centered">
                        We are driven to improve the lives of our clients, our employees, and our community through our commitment to leadership, excellence in craft, and attention to detail.
                    </p>
                </div>

                <div className="leadership-slider-wrapper">
                    <button className="nav-arrow prev" onClick={() => moveSlide(currentIndex - 1)}><ChevronLeft size={24} /></button>
                    
                    <div className="leadership-viewbox">
                        <motion.div
                            className="leadership-grid-inner"
                            animate={controls}
                            style={{ display: 'flex' }}
                        >
                            {[...leaders, ...leaders, ...leaders].map((leader, index) => (
                                <div key={index} className="leader-card-box" style={{ 
                                    flex: `0 0 ${100 / cardsToShow}%`, 
                                    minWidth: `${100 / cardsToShow}%` 
                                }}>
                                    <div className="leader-item">
                                        <div className="leader-image-bg">
                                            <img src={leader.image.src || leader.image} alt={leader.name} draggable="false" />
                                        </div>
                                        <div className="leader-content">
                                            <h3 className="name-green">{leader.name}</h3>
                                            <p className="role-white">{leader.role}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </motion.div>
                    </div>

                    <button className="nav-arrow next" onClick={() => moveSlide(currentIndex + 1)}><ChevronRight size={24} /></button>
                </div>
            </div>
        </section>
    );
};

export default Aboutus9;
